import Activity from './Activity.jsx';

export default Activity;
